import { StorageService } from './services/storage';

/**
 * Validates browser storage (cookies and localStorage) and displays warning if unavailable.
 */
const storageService = new StorageService();

if (!navigator.cookieEnabled || !storageService.localStorage.isAvailable()) {
  document.querySelector('#no-cookies-warning').classList.remove('hide');
}
